import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { useOsanoScript } from '@trinity/chat-components/hooks/useOsanoScript';
import { NavBar } from '@/components/Nav/NavBar';
import { config } from '@/config';
import { FaqSwitchProvider } from '@/contexts/FaqSwitchContext';
import { DocumentHelmet } from './Helmet';

type OsanoScriptLoaderProps = {
  src: string;
};

const OsanoScriptLoader = ({ src }: OsanoScriptLoaderProps) => {
  useOsanoScript({ visible: false, src });

  return null;
};

export const Layout = () => {
  const appConfig = config();

  return (
    <FaqSwitchProvider>
      <DocumentHelmet />
      {appConfig.OSANO_ENABLED && <OsanoScriptLoader src={appConfig.OSANO_SCRIPT_SRC} />}
      <NavBar />
      <MainContent>
        <Outlet />
      </MainContent>
      <Toast />
    </FaqSwitchProvider>
  );
};

const MainContent = styled.main({
  paddingTop: `var(--navbar-height)`,
});
